import { NUMBER_PLATE_RULES, VehicleNumberPlateType } from '~/shared';

export const validateNumberPlate = (
	type: VehicleNumberPlateType,
	text: string,
	regionCodeParam: string,
) => {
	const rules = NUMBER_PLATE_RULES[type];
	if (!rules) return true;

	if (rules.text && !rules.text.test(text)) {
		return false;
	}

	if (rules.region && regionCodeParam && !rules.region.test(regionCodeParam)) {
		return false;
	}

	return true;
};

export const isCustomType = (type: VehicleNumberPlateType) => {
	return (
		type === VehicleNumberPlateType.Custom ||
		type === VehicleNumberPlateType.CustomBlack
	);
};
